import '@fortawesome/fontawesome-pro/css/all.css'
import * as _ from 'underscore'

import './prizmdoc/normalize.min.css'
import './prizmdoc/viewer.scss'
import './prizmdoc/nextrequest.scss'
import '../../../../public/viewer-assets/css/viewercontrol.css'
import NrSentry from './nr_sentry'

// Load scripts dynamically for Vite
const loadScript = (src: string) => {
  return new Promise<void>((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      return resolve()
    }
    const script = document.createElement('script')
    script.src = src
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`))
    document.head.appendChild(script)
  })
}

// Load PrizmDoc scripts in order
const loadPrizmdocAssets = async () => {
  window._ = _

  try {
    // These need to be loaded via dynamic script tags for proper execution
    await loadScript('/viewer-assets/js/html5shiv.js')
    await loadScript('/viewer-assets/js/viewercontrol.js')

    // Load local scripts
    const { default: hotkeys } = await import(
      './prizmdoc/jquery.hotkeys.min.js?url'
    )
    await loadScript(hotkeys)

    const { default: customizations } = await import(
      './prizmdoc/viewerCustomizations.js?url'
    )
    await loadScript(customizations)

    // Import the viewer module
    await import('./prizmdoc/viewer.js')
  } catch (error) {
    NrSentry.captureError(error)
    window.alert('Viewer failed to load. Please refresh the page.')
  }
}

export default loadPrizmdocAssets
